import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

import AppLayout from "./AppLayout";

const HomePage            = lazy(() => import("./HomePage/HomePage"));
const ServicePage         = lazy(() => import("features/services/components/ServicePage/ServicePage"));
const ServicesPage        = lazy(() => import("features/services/components/ServicesPage/ServicesPage"));
const AddServicePage      = lazy(() => import("features/services/components/AddServicePage/AddServicePage"));
const ProjectPage         = lazy(() => import("features/projects/components/ProjectPage/ProjectPage"));
const ProjectsPage        = lazy(() => import("features/projects/components/ProjectsPage/ProjectsPage"));
const AddProjectPage      = lazy(() => import("features/projects/components/AddProjectPage/AddProjectPage"));
const ClientsPage         = lazy(() => import("features/clients/components/ClientsPage/ClientsPage"));
const AddClientPage       = lazy(() => import("features/clients/components/AddClientPage/AddClientPage"));
const NotificationsPage   = lazy(() => import("features/notifications/components/NotificationsPage/NotificationsPage"));
const NotificationPage    = lazy(() => import("features/notifications/components/NotificationPage/NotificationPage"));
const ChecksLogsPage      = lazy(() => import("features/checksLogs/components/ChecksLogsPage/ChecksLogsPage"));
const ChangeLogPage       = lazy(() => import("features/changelog/components/ChangeLogPage/ChangeLogPage"));
const NotFoundPage        = lazy(() => import("components/feedback/NotFoundPage/NotFoundPage"));

export default function AppRouter() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/"                               element={<HomePage />} />
        <Route path="/clients"                        element={<ClientsPage />} />
        <Route path="/projects"                       element={<ProjectsPage />} />
        <Route path="/projects/:projectId"            element={<ProjectPage />} />
        <Route path="/services"                       element={<ServicesPage />} />
        <Route path="/services/:serviceId"            element={<ServicePage />} />
        <Route path="/add-project/:clientId"          element={<AddProjectPage action="add" />} />
        <Route path="/edit-project/:projectId"        element={<AddProjectPage action="edit" />} />
        <Route path="/add-service/:projectId"         element={<AddServicePage action="add" />} />
        <Route path="/add-service"                    element={<AddServicePage action="add" />} />
        <Route path="/edit-service/:serviceId"        element={<AddServicePage action="edit" />} />
        <Route path="/add-client"                     element={<AddClientPage action="add" />} />
        <Route path="/edit-client/:clientId"          element={<AddClientPage action="edit" />} />
        <Route path="/checkslogs"                     element={<ChecksLogsPage />} />
        <Route path="/changelog"                      element={<ChangeLogPage />} />
        <Route path="/notifications"                  element={<NotificationsPage />} />
        <Route path="/notifications/:notificationId"  element={<NotificationPage />} />
        <Route path="*"                               element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
